<div class="read-container-params">
    <h4>{{'PRAMETERS'|translate}}</h4>

    <mat-slide-toggle [ngModel]="deviceParamLirisV3.powerMode === 1" [disabled]="true">
        {{'POWER_MODE'|translate}}
    </mat-slide-toggle>

    <mat-divider></mat-divider>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} A" [value]="deviceParamLirisV3.paramA" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} B" [value]="deviceParamLirisV3.paramB" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} C" [value]="deviceParamLirisV3.paramC" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'TRIGGER'|translate}}" [value]="deviceParamLirisV3.calibTrigger" [readonly]="true">
    </mat-form-field>
    <mat-divider></mat-divider>


    <mat-form-field>
        <input matInput placeholder="K1" [value]="deviceParamLirisV3.k1" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="K2" [value]="deviceParamLirisV3.k2" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="K3" [value]="deviceParamLirisV3.k3" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="K4" [value]="deviceParamLirisV3.k4" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="K5" [value]="deviceParamLirisV3.k5" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="K6" [value]="deviceParamLirisV3.k6" [readonly]="true">
    </mat-form-field>
</div>
<div class="read-container-params">
    <h4>{{'PRAMETERS'|translate}}</h4>


    <mat-form-field>
        <input matInput placeholder="{{'EXTENSION_BOARD_TYPE'|translate}} " [value]="deviceParamLirisV3.extBoardType"
               [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'SENSOR_BOARD_SN'|translate}}" [value]="deviceParamLirisV3.sensorBoardSN"
               [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'CHART_TEMPERATURE'|translate}}" [value]="deviceParamLirisV3.temperature" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'FAB_BENCH_SN'|translate}}" [value]="deviceParamLirisV3.fabBenchSN"
               [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'ASSEMBLY_VERSION'|translate}}" [value]="deviceParamLirisV3.assemblyVersion" [readonly]="true">
    </mat-form-field>
</div>

<div class="read-container-params">
    <h4>{{'PRAMETERS'|translate}}</h4>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} A Stretch" [value]="deviceParamLirisV3.paramAStretch" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} B Stretch" [value]="deviceParamLirisV3.paramBStretch" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} C Stretch" [value]="deviceParamLirisV3.paramCStretch" [readonly]="true">
    </mat-form-field>
    <mat-divider></mat-divider>
    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} A Comp" [value]="deviceParamLirisV3.paramAComp" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} B Comp" [value]="deviceParamLirisV3.paramBComp" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="{{'PRAMETER'|translate}} C Comp" [value]="deviceParamLirisV3.paramCComp" [readonly]="true">
    </mat-form-field>
</div>
<div class="read-container-params">
    <h4>{{'PRAMETERS'|translate}}</h4>
    <mat-form-field>
        <input matInput placeholder="Calib Start Point" [value]="deviceParamLirisV3.calibStartPoint" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Calib Raw Point" [value]="deviceParamLirisV3.calibEndPoint" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Calib Raw Ref" [value]="deviceParamLirisV3.calibRawRef" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Calib Raw Meas" [value]="deviceParamLirisV3.calibRawMeas" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Calib Raw Meas WP" [value]="deviceParamLirisV3.calibRawMeasWp" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Hysteresis" [value]="deviceParamLirisV3.hysteresis" [readonly]="true">
    </mat-form-field>
</div>